import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  h4Message:string = $localize`La nada <span>absoluta</span>.`;
  paragraphMessage:string = $localize`Lo que buscas, no parece estar aqui..`;
  buttonMessage:string = $localize`Regresemos`;
  constructor() { }

  ngOnInit(): void {
  }

}
